import React from "react"

import { ContainerLayout } from "../../components/Layout"
import { LoginForm, LoginLogo } from "../../components/Login"

function Login({ register, handleCantAccess, handleSubmit, handleIsRecovery, isRecovery, logo }) {
  return (
    <ContainerLayout containerClass={"login-content"}>
      <LoginLogo logo={logo} />
      <LoginForm register={register} handleCantAccess={handleCantAccess} handleSubmit={handleSubmit} handleIsRecovery={handleIsRecovery} isRecovery={isRecovery} logo={logo} />
    </ContainerLayout>
  )
}

export default Login
